var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.536 3.833l-1.2 1.2-2.367-2.366 1.2-1.2a.434.434 0 01.313-.134c.12 0 .234.047.32.134L14.536 3.2a.45.45 0 01.133.32c0 .12-.047.233-.133.313zM4.182 14.187a.403.403 0 01-.24.126l-2.08.347a.425.425 0 01-.393-.127.423.423 0 01-.127-.386l.347-2.087a.403.403 0 01.127-.24l8.68-8.68 2.366 2.367-8.68 8.68zM15.01 2.727L13.276.993a1.174 1.174 0 00-.3-.213c-.4-.113-.447-.113-.494-.113-.173 0-.34.04-.492.113a1.141 1.141 0 00-.294.213l-1.674 1.674-8.68 8.68a1.113 1.113 0 00-.313.606l-.347 2.08c-.06.36.054.714.314.974.214.213.494.326.786.326.067 0 .127-.006.187-.013l2.08-.347c.233-.04.447-.153.607-.313L15.01 4.307c.213-.207.327-.487.327-.787 0-.3-.114-.58-.327-.793z",
    fill: "#000"
  })));
}
SvgEdit.displayName = 'Edit';
export default SvgEdit;